module.exports = __webpack_public_path__ + "media/images/befit-logo-004743905e161ad1f924b6e220aeaf9e.webp";